import * as React from 'react';



export default class Email extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
        <svg viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" className={this.props.className}>
        <g id="Manage-profile" stroke="" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g id="Profile-notifications-settings" transform="translate(-974.000000, -72.000000)" stroke="">
            <g id="Group-15" transform="translate(257.000000, 72.000000)">
                <g id="Group-13" transform="translate(694.000000, 0.000000)">
                    <g id="Group-4" transform="translate(23.000000, 0.000000)">
                        <g id="Group-7" transform="translate(0.705882, 4.353111)">
                            <polygon id="Stroke-2" points="0.526347009 15.5990111 21.9630252 15.5990111 21.9630252 0.587211845 0.526347009 0.587211845"></polygon>
                            <polyline id="Stroke-4" points="0.526806367 0.587671203 11.2451455 8.47943103 21.9634846 0.587671203"></polyline>
                            <line x1="0.526806367" y1="15.5990111" x2="8.98204473" y2="7.14224169" id="Stroke-5"></line>
                            <line x1="21.9634846" y1="15.5990111" x2="13.4868095" y2="6.82834748" id="Stroke-6"></line>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
        </svg>
    )
  }
}
